import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { LandingNav, Hero, Marquee, Mirror } from "@/screens/landing/Top";
import { Bento, Breathe, Quote, LandingPricing, Faq, FinalCta } from "@/screens/landing/Sections";
import { SiteFooter } from "@/components/hm/SiteFooter";
import { WelcomeModule } from "@/screens/landing/WelcomeModule";
import { ParentsTeaser } from "@/screens/landing/Parents";
import { YouthVideo } from "@/screens/landing/YouthVideo";

export default function Landing() {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    const target = pathname === "/como-funciona" ? "#como" : hash;
    if (!target) return;
    const go = () => document.querySelector(target)?.scrollIntoView({ behavior: "instant" });
    const t1 = setTimeout(go, 250);
    const t2 = setTimeout(go, 900);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [hash, pathname]);
  return (
    <>
      <LandingNav />
      <main id="top">
        <Hero />
        <Marquee />
        <Mirror />
        <ParentsTeaser />
        <WelcomeModule />
        <YouthVideo />
        <Breathe />
        <Bento />
        <Quote />
        <LandingPricing />
        <Faq />
        <FinalCta />
      </main>
      <SiteFooter />
    </>
  );
}
